import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-095b4806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }

import { computed, onBeforeMount, onMounted, ref, watch, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTokenManager } from '@/auth/TokenManager'
import { useAppHostStore } from './AppHostStore'
import { useGroupAdminNotifications } from '@/gp/GroupAdminNotifications'
import { useResearchDataNotifications } from '@/rd/ResearchDataNotifications'
import { useUserStore } from './gp/UserStore'
import { useExploreStore } from './explore/ExploreStore'
import { LoadMode } from './util/AsyncData'
import { reloadApp } from './util/AppUtil'
import SiteNotify from './site/SiteNotify.vue'
import SiteHeader from '@/site/SiteHeader.vue'
import SiteFooter from '@/site/SiteFooter.vue'
import ErrorModal from '@/util/ErrorModal.vue'
import { siteNotifyEvent } from './site/SiteNotifyEvent'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const notifyRef = ref<InstanceType<typeof SiteNotify>>()

const route = useRoute()
const router = useRouter()
const appHostStore = useAppHostStore()
const tokenManager = useTokenManager()
const gpNotify = useGroupAdminNotifications()
const rdNotify = useResearchDataNotifications()
const userStore = useUserStore()
const exploreStore = useExploreStore()

watch(() => tokenManager.current.userId, (newValue, oldValue) => {
  if (oldValue) {
    reloadApp() // reload entire app whenever switching users or signing out
  }
})

watchEffect(() => {
  if (router.currentRoute.value.query.embed == 'true') {
    appHostStore.isEmbedded = true // set the first time we see it, but don't expect it to be present on every page
  }
})

const loadingRef = ref(true)

const pagesWithoutHeader = [ '/signin/approve' ]
const showHeaderRef = computed(() => !appHostStore.isEmbedded && !pagesWithoutHeader.includes(route.path))

const pagesWithFooter = [ '/', '/contact', '/about', '/privacy', '/terms', '/learn/faq', '/learn/sync', '/learn/research', '/learn/compare', '/plans', '/support'  ]
const showFooterRef = computed(() => pagesWithFooter.includes(route.path))

const fullWidthPages = [ '/', '/home', '/start/family', '/start/dev', '/start/new-tree' ]
const useContainerRef = computed(() => !fullWidthPages.includes(route.path) && !route.path.startsWith('/games/'))

// start app-level initialization BEFORE mounting any child components (some of it is async, so may continue after mounting)
onBeforeMount(async () => {
  tokenManager.startAutoRefresh() // async (fire-and-forget)

  window.addEventListener('load', () => {
    loadingRef.value = false
  })

  gpNotify.initialize()
  rdNotify.initialize()

  exploreStore.ensureClientLocationLoaded()

  if (tokenManager.current.isValid) {
    // load self user immediately
    const selfUser = await userStore.getAsyncSelf(LoadMode.EnsureLoaded)?.whenLoadCompleted // loads profile group inline
  }
})

onMounted(() => {
  siteNotifyEvent.on((args) => notifyRef.value?.show(args))
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app", { loading: loadingRef.value }])
  }, [
    (showHeaderRef.value)
      ? (_openBlock(), _createBlock(SiteHeader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(SiteNotify, {
      ref_key: "notifyRef",
      ref: notifyRef
    }, null, 512),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { embedded: _unref(appHostStore).isEmbedded, 'container-md': useContainerRef.value }])
    }, [
      _createVNode(_component_router_view)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (showFooterRef.value)
        ? (_openBlock(), _createBlock(SiteFooter, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ErrorModal)
  ], 2))
}
}

})